import React, { Component } from 'react';
import { connect } from 'react-redux';
import { displayContactModal } from 'actions/visibility';
import { withRouter, NavLink } from 'react-router-dom';
import classNames from "classnames/bind"

import { Clearfix } from "components/shared/clearfix/Clearfix";
import { DesktopHeader } from "components/shared/header/desktopHeader/DesktopHeader";
import { MobileHeader } from "components/shared/header/mobileHeader/MobileHeader"
import { SectionDivider } from "components/shared/sectionDivider/SectionDivider";
import logo from 'images/tampa-bay-web-developer-logo-w-text.jpg';
import styles from "./header.module.scss"

const cx = classNames.bind(styles)

class Header extends Component {
  displayContactModal = (e) => {
    e.preventDefault();
    this.props.displayContactModal();
  }

  navigationItems = [
      {
          text: 'Home',
          link: '/',
          exact: true
      },
      {
          text: 'About',
          link: '/about'
      },
      {
          text: 'Portfolio',
          link: '/portfolio',
          subNav: [
              {
                text: 'onXmaps',
                link: '/portfolio/onxmaps'
              },
              {
                  text: 'Hunting GPS Maps',
                  link: '/portfolio/hunting-gps-maps'
              },
              {
                  text: 'Roam Maps',
                  link: '/portfolio/roam-gps-maps'
              },
              {
                  text: 'Report Tool',
                  link: '/portfolio/onxmaps-reporting-tool'
              },
              {
                  text: 'Acclaris',
                  link: '/portfolio/acclaris'
              },
              {
                  text: 'Where To Buy',
                  link: '/portfolio/where-to-buy'
              }
          ]
      },
      {
          text: 'Skills',
          link: '/skills'
      },
      // {
      //     text: 'Career History',
      //     link: '/career-history'
      // },
      {
          text: 'Blog',
          link: '/blog'
      }
  ]

  componentDidUpdate = () => {
      // Makes the application scroll to the top on change
      window.scrollTo(0, 0)
  }

  redirectRoute = (route) => {
    this.props.history.push(route);
  }

  render() {
    const { displayContactModal } = this.props

    return (
      <header>
        <div className={cx(['container', 'header-container'])}>
            <div id={cx('logoWrapper')}>
                <NavLink to="/">
                    <img srcSet={logo} alt="Tampa Bay Professional Web Developer Logo"/>
                </NavLink>
            </div>

            <DesktopHeader
                navigationItems={this.navigationItems}
                redirectRoute={this.redirectRoute}
                displayContactModal={displayContactModal}
            />

            <MobileHeader
                navigationItems={this.navigationItems}
                redirectRoute={this.redirectRoute}
                displayContactModal={displayContactModal}
            />

          <Clearfix />
        </div> 
        <SectionDivider />
      </header>
    );
  }
}

const mapDispatchToProps = dispatch => ({
    displayContactModal: () => dispatch(displayContactModal())
});

const HeaderWithRouter = withRouter(Header)

export default connect(undefined, mapDispatchToProps)(HeaderWithRouter);
